import moment from "moment";
import { ClientBilling } from "../../types";
import { formatCurrencyPrecise } from "../../utils";

export function ChargeAuditPanel({ client }: { client: ClientBilling }) {
  if (
    !(
      client.isManualOverride ||
      (client.rechargeCount ?? 0) > 0 ||
      (client.autoRetryCount ?? 0) > 0 ||
      (client.resetCount ?? 0) > 0
    )
  ) {
    return null;
  }
  return (
    <div className="bg-surface-secondary rounded-lg p-4 space-y-2">
      <div className="text-xs text-content-tertiary uppercase tracking-wider font-medium">
        Audit
      </div>

      {client.isManualOverride && (
        <div className="space-y-1">
          <div className="inline-block text-[11px] font-medium text-amber-700 bg-amber-100 border border-amber-300 rounded px-1.5 py-0.5">
            Manual override
          </div>
          {client.calculatedAmount != null && (
            <div className="flex justify-between text-xs">
              <span className="text-content-secondary">
                Calculated vs charged
              </span>
              <span className="text-content-primary font-medium">
                {formatCurrencyPrecise(client.calculatedAmount)} →{" "}
                {formatCurrencyPrecise(
                  client.totalAmount ?? client.commission,
                )}
              </span>
            </div>
          )}
          {client.createdByName && (
            <div className="flex justify-between text-xs">
              <span className="text-content-secondary">Charged by</span>
              <span className="text-content-primary font-medium">
                {client.createdByName}
                {client.chargedAt && moment(client.chargedAt).isValid()
                  ? ` · ${moment(client.chargedAt).format("MMM D, YYYY")}`
                  : ""}
              </span>
            </div>
          )}
          {client.overrideReason && (
            <div className="text-xs">
              <span className="text-content-secondary">Reason: </span>
              <span className="text-content-primary">
                {client.overrideReason}
              </span>
            </div>
          )}
        </div>
      )}

      {(client.rechargeCount ?? 0) > 0 && (
        <div className="flex justify-between text-xs">
          <span className="text-content-secondary">Re-charged</span>
          <span className="text-content-primary font-medium">
            {client.rechargeCount}×
            {client.lastRechargedByName
              ? ` · last by ${client.lastRechargedByName}`
              : ""}
            {client.lastRechargedAt &&
            moment(client.lastRechargedAt).isValid()
              ? ` on ${moment(client.lastRechargedAt).format("MMM D, YYYY")}`
              : ""}
          </span>
        </div>
      )}

      {(client.autoRetryCount ?? 0) > 0 && (
        <div className="flex justify-between text-xs">
          <span className="text-content-secondary">Auto-retried</span>
          <span className="text-content-primary font-medium">
            {client.autoRetryCount} of 4
            {client.lastAutoRetryAt &&
            moment(client.lastAutoRetryAt).isValid()
              ? ` · last on ${moment(client.lastAutoRetryAt).format("MMM D, YYYY")}`
              : ""}
          </span>
        </div>
      )}

      {(client.resetCount ?? 0) > 0 && (
        <div className="flex justify-between text-xs">
          <span className="text-content-secondary">
            Reset for re-bill
          </span>
          <span className="text-content-primary font-medium">
            {client.resetCount}×
            {client.lastResetByName
              ? ` · last by ${client.lastResetByName}`
              : ""}
            {client.lastResetAt && moment(client.lastResetAt).isValid()
              ? ` on ${moment(client.lastResetAt).format("MMM D, YYYY")}`
              : ""}
          </span>
        </div>
      )}
    </div>
  );
}
